module.exports = __webpack_public_path__ + "static/media/icon-account-activated.62b3ac1c.svg";